module.exports = __webpack_public_path__ + "svg/flags/Côte d'Ivoire.svg";